module.exports = __webpack_public_path__ + "img/petstairs08.b14d57b8.jpg";